import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Wrap, InputKey, TagList, Tag } from './styles';
import PageSectionDivider from '../../../components/Layout/Content/PageSectionDivider';

const isValid = (key, value) => {
  return (key === 'Enter' || key === ',') && value !== '' && value !== ',';
};

const Tags = ({ tags, setTags }) => {
  const [value, setValue] = useState('');

  const onKeyUp = ({ key }) => {
    if (isValid(key, value)) {
      setTags([...tags, value.replace(',', '')]);
      setValue('');
    }
  };

  const onDelete = tagToRemove => {
    setTags(tags.filter(tag => tag !== tagToRemove));
  };

  return (
    <Wrap>
      <InputKey
        label="Tags"
        placeholder="type-tag (and press Enter) or use comma, to separate"
        value={value}
        width="750px"
        onChange={setValue}
        onKeyUp={onKeyUp}
      />
      <TagList>
        {tags.map((tag, i) => (
          <Tag
            key={`${tag}-${i}`}
            variant="outlined"
            label={tag}
            onDelete={() => onDelete(tag)}
          />
        ))}
      </TagList>
      <PageSectionDivider size="S" />
    </Wrap>
  );
};

Tags.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  setTags: PropTypes.func.isRequired,
};

export default Tags;
